"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionsTricolon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ActionsTricolonStyled = _styledComponents["default"].a.withConfig({
  displayName: "ActionsTricolon__ActionsTricolonStyled",
  componentId: "sc-1r1jq6h-0"
})(["color:white;font-size:22px;width:25px;height:25px;font-weight:900;text-align:center;align-self:center;opacity:1;transition:0.2s ease-in-out;border-radius:12px;&:hover{cursor:pointer;background-color:#98bcdf;}"]);

var ActionContainer = _styledComponents["default"].div.withConfig({
  displayName: "ActionsTricolon__ActionContainer",
  componentId: "sc-1r1jq6h-1"
})(["display:flex;flex-direction:column;"]);

var ActionStyled = _styledComponents["default"].span.withConfig({
  displayName: "ActionsTricolon__ActionStyled",
  componentId: "sc-1r1jq6h-2"
})(["width:100%;&:hover{cursor:pointer;background-color:#98bcdf;}"]);

var Tricolon = _styledComponents["default"].div.withConfig({
  displayName: "ActionsTricolon__Tricolon",
  componentId: "sc-1r1jq6h-3"
})(["transform:rotate(90deg);font-weight:100;line-height:17px;padding-bottom:7px;"]);

var ActionsTricolon = function ActionsTricolon(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? Math.random() : _ref$id,
      tooltipClassName = _ref.tooltipClassName,
      _ref$tooltipPlacement = _ref.tooltipPlacement,
      tooltipPlacement = _ref$tooltipPlacement === void 0 ? "right" : _ref$tooltipPlacement,
      _ref$hoverCallback = _ref.hoverCallback,
      hoverCallback = _ref$hoverCallback === void 0 ? function () {} : _ref$hoverCallback;
  return /*#__PURE__*/_react["default"].createElement(ActionsTricolonStyled, {
    "data-for": "actions-".concat(id),
    "data-tip": true
  }, /*#__PURE__*/_react["default"].createElement(Tricolon, {
    onMouseEnter: function onMouseEnter() {
      hoverCallback();
    }
  }, "..."), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    id: "actions-".concat(id),
    clickable: true,
    effect: "solid",
    place: tooltipPlacement,
    type: "light",
    delayHide: 200,
    "data-class": tooltipClassName,
    className: tooltipClassName
  }, /*#__PURE__*/_react["default"].createElement(ActionContainer, null, actions.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(ActionStyled, {
      key: action.description,
      onClick: action.action
    }, action.description);
  }))));
};

exports.ActionsTricolon = ActionsTricolon;